import React, { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import Loader from '../Loader';
import { sendAccessToken } from '../../api/mutations';

// Isolated auth hand-off: rendered (instead of the page) whenever the URL
// carries an access_token. It runs ONLY the signIn mutation — no page/layout
// queries mount — then reloads the same path without the token.
//
// Why: Rails re-issues `_binaaz_session` on every GraphQL response. If page
// queries run concurrently with signIn, a non-auth response can land after
// signIn and overwrite the authenticated session (last-write-wins) →
// intermittent logout. Rendering signIn alone makes it the sole writer; the
// subsequent full reload then carries the authenticated cookie on every
// request. Returns the user to the same page they started auth from.
const AuthHandoff = () => {
  const redirectToCleanUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('access_token');
    window.location.replace(url.pathname + url.search);
  };

  const [mutateToken] = useMutation(sendAccessToken, {
    onCompleted: redirectToCleanUrl,
    onError: redirectToCleanUrl
  });

  useEffect(() => {
    const accessToken = new URLSearchParams(window.location.search).get(
      'access_token'
    );

    if (accessToken) {
      mutateToken({ variables: { accessToken } });
    } else {
      redirectToCleanUrl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh'
      }}
    >
      <Loader loading pageLoader />
    </div>
  );
};

export default AuthHandoff;
